import { IWbUserInfo } from '@interco/inter-webview-bridge'

export const USER_INFO: IWbUserInfo = {
  account: '12345678',
  cpf: '12345678909',
  name: 'User',
  email: 'user@bancointer.com.br',
  phoneNumber: '31999999999',
  cellPhoneNumber: '',
  profile: '',
  birthDate: 0,
  userType: 'basic_account',
  segmentation: 'DIGITAL',
}
